"use client";
import { useState, useEffect, useCallback } from "react";
import { followEvents } from "@/lib/optimized-follow-events";

const followCache = new Map<string, boolean>();

export function useFollowStatus(profileId: string, initialFollowing: boolean) {
  const cacheKey = `follow:${profileId}`;
  
  const [following, setFollowing] = useState(() => {
    if (followCache.has(cacheKey)) {
      return followCache.get(cacheKey)!;
    }
    followCache.set(cacheKey, initialFollowing);
    return initialFollowing;
  });

  useEffect(() => {
    const handleFollowChange = () => {
      const cached = followCache.get(cacheKey);
      if (cached !== undefined && cached !== following) {
        setFollowing(cached);
      }
    };

    const unsubscribe = followEvents.onFollowChange(handleFollowChange);
    return unsubscribe;
  }, [cacheKey, following]);

  const updateFollowStatus = useCallback((newStatus: boolean) => {
    followCache.set(cacheKey, newStatus);
    setFollowing(newStatus);
    followEvents.emitFollowChange();
  }, [cacheKey]);

  return { following, updateFollowStatus };
}

